module.exports = __webpack_public_path__ + "static/img/texun444.67f2bc4.png";